import Modern71 from '../../Residential/Modern Mansion/Modern Mansion (2).webp'
import Modern72 from '../../Residential/Modern Mansion/Modern Mansion (2).webp'


const Modern7images =[
Modern71,Modern72
]

export default Modern7images;